import { money } from "@/lib/scoring";
import { displayName } from "@/data/nicknames";

const shortDate = (iso) => new Date(`${iso}T12:00:00`).toLocaleDateString("en-US", { month: "short", day: "numeric" });

const Holders = ({ holders, singleDate }) =>
  singleDate ? (
    <>
      {holders.map((h, i) => (
        <span key={h.name}>
          {i > 0 && <span className="text-cypress-cream/40"> · </span>}
          <span className="font-semibold tracking-tight">{displayName(h.name)}</span>
        </span>
      ))}
      <span className="text-cypress-cream/50">, through {shortDate(holders[0].date)}</span>
    </>
  ) : (
    holders.map((h, i) => (
      <span key={`${h.name}-${h.date}`}>
        {i > 0 && <span className="text-cypress-cream/40"> · </span>}
        <span className="font-semibold tracking-tight">{displayName(h.name)}</span>
        <span className="text-cypress-cream/50">, {shortDate(h.date)}</span>
      </span>
    ))
  );

const Row = ({ label, record, format, testId, singleDate = false }) => {
  if (!record) return null;
  return (
    <li className="grid grid-cols-[1fr_auto] gap-x-3 gap-y-0.5 py-2 sm:grid-cols-[auto_1fr_auto] sm:items-baseline" data-testid={testId}>
      <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-cypress-cream/50">{label}</span>
      <span className="row-span-2 self-center font-mono text-base font-bold text-cypress-gold sm:order-3 sm:row-span-1 sm:self-auto">{format(record.value)}</span>
      <span className="text-sm leading-snug sm:order-2 sm:text-right">
        <Holders holders={record.holders} singleDate={singleDate} />
      </span>
    </li>
  );
};

export const RecordsStrip = ({ records }) => (
  <div className="mt-8 rounded-xl border border-cypress-gold/20 bg-cypress-green/30 px-4 py-3" data-testid="records-strip">
    <p className="text-xs font-bold uppercase tracking-[0.3em] text-cypress-gold">Records</p>
    <ul className="mt-1 divide-y divide-cypress-gold/10">
      <Row label="Most dots in a round" record={records.mostDots} format={(v) => `${v} dots`} testId="record-most-dots" />
      <Row label="Biggest single payday" record={records.biggestPayday} format={money} testId="record-biggest-payday" />
      <Row label="Most rounds played" record={records.mostRounds} format={(v) => `${v} rounds`} testId="record-most-rounds" singleDate />
      <Row label="Most goose eggs" record={records.mostGooseEggs} format={(v) => `${v} eggs`} testId="record-most-goose-eggs" />
    </ul>
  </div>
);
